// extracted by mini-css-extract-plugin
var _1 = "Editor_colorButton__DUqGL";
var _2 = "Editor_colorButtonActive__gr5v-";
var _3 = "Editor_colorButtons__Tnau1";
var _4 = "Editor_text__zolDF";
export { _1 as "colorButton", _2 as "colorButtonActive", _3 as "colorButtons", _4 as "text" }
